import styled from 'styled-components';
import { Banner, useApplyMobileSettings } from '@elfsight/widget-banner/widget';
import { Deactivation2 } from '@elfsight/widget-deactivation';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../meta';
import { getDirection } from '../utils';

export function Main() {
  const settings = useSettings();

  const {
    blocks,
    bannerLink,
    contentAlignment,
    bannerBackground,
    stretchBackground,
    bannerWidth,
    verticalBannerHeight,
    horizontalBannerHeight,
    contentPadding,
    contentSpacing,
    mobileContentPadding,
    mobileContentSpacing,
    editMode,
    widgetToken,
    widgetId,
    layout
  } = settings;

  const direction = getDirection(layout);

  const applyMobileSettings = useApplyMobileSettings(bannerWidth);

  const selectContentIndents = (indent: number, mobileIndent: number) => {
    if (applyMobileSettings) {
      return mobileIndent;
    }

    return indent;
  };

  if (!blocks?.length && editMode) {
    return (
      <Empty style={{ width: bannerWidth ? `${bannerWidth}px` : 'auto' }}>
        Add at least 1 element to display Banner
      </Empty>
    );
  }

  return (
    <Deactivation2 appAlias={meta.alias} {...settings}>
      <Banner
        blocks={blocks}
        bannerLink={bannerLink}
        contentAlignment={contentAlignment}
        bannerBackground={bannerBackground}
        stretchBackground={stretchBackground}
        bannerWidth={bannerWidth}
        verticalBannerHeight={verticalBannerHeight}
        horizontalBannerHeight={horizontalBannerHeight}
        contentPadding={selectContentIndents(
          contentPadding,
          mobileContentPadding
        )}
        contentDirection={direction}
        contentSpacing={selectContentIndents(
          contentSpacing,
          mobileContentSpacing
        )}
        style={{
          overflow: 'visible'
        }}
        editMode={editMode}
        widgetToken={widgetToken}
        widgetId={widgetId}
        submitAdditionalData={{
          type: 'banner'
        }}
      />
    </Deactivation2>
  );
}

const Empty = styled.div`
  margin: 0 auto;
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;
  text-align: center;
`;
